// extracted by mini-css-extract-plugin
export default {"Headers":"Header_Headers__fIOCq"};